import { JsonLd } from '../JsonLd';

interface ServiceLdProps {
  name: string;
  description: string;
  url: string;
  areaServed?: string;
}

export function ServiceLd({
  name,
  description,
  url,
  areaServed = 'France',
}: ServiceLdProps) {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: name,
    description,
    url,
    provider: { '@type': 'Organization', name: 'Solution Éco France' },
    areaServed,
  };
  return <JsonLd schema={data} />;
}
